/**
 * Build an auth-flow URL that carries the shareId through (WS5 / gap-finding
 * F5). Post-auth, `linkSharesForUser` consumes `?share=<id>` so the recipient
 * gets the deal linked to their account; `?next=/deal/<id>` returns them to the
 * deal. EVERY conversion CTA on the public deal-link surface (header Login +
 * Unlock, the in-thread 3-question gate, the recovery fallback, the Unlock
 * panel, and the Model-tab sandbox sign-up) must carry it so post-auth linking
 * fires. Falls back to the bare path when shareId is absent (owner-preview /
 * null-share / error-surface context).
 *
 * Promoted out of `PublicChromeShell.tsx` (2026-06-04) so the in-thread CTAs +
 * `<UnlockFullArcanumAccessPrompt>` + `<DealModelView>` reuse the SAME builder
 * rather than hand-rolling a second `encodeURIComponent` copy that could drift.
 */
export function authUrlWithShare(
  base: '/login' | '/signup',
  shareId?: string
): string {
  if (!shareId) return base;
  const next = `/deal/${encodeURIComponent(shareId)}`;
  return `${base}?next=${encodeURIComponent(next)}&share=${encodeURIComponent(
    shareId
  )}`;
}
